import type { JsonExchange } from '@skynet/data-shared-exchanges';
import type { TaskActions, TaskTypes } from '../apiKeys/types';

export { TaskStatus } from '@skynet/types-task-status';

export enum TradingTasksCommands {
  Tasks = 'Tasks',
  PauseTask = 'PauseTask',
  ResumeTask = 'ResumeTask',
  CancelTask = 'CancelTask',
  UpdateTask = 'UpdateTask',
}

export enum TaskState {
  Paused = 0,
  Active = 1,
  Terminal = 2,
  RecentlyFinished = -1,
}

export interface UpdateTaskPayload {
  id: number;
  priceLimit?: number;
  orderSize?: number;
  orderPeriod?: number;
  aggression?: number;
  liquidity?: number;
}

export interface UpdateTaskValueForm {
  id: number;
  ticker: string;
  type: TaskTypes;
  lastPrice?: number;
  priceLimit?: number;
  orderSize?: number;
  orderSizeSlider?: number;
  orderPeriod?: number;
  action: TaskActions;
  aggression?: number;
  liquidity?: number;
  liquiditySlider?: number;
  aggressionSlider?: number;
}

export interface JsonTradingTask {
  aggression: number;
  liquidity: number;
  id: number;
  action: TaskActions;
  type: TaskTypes;
  company: string;
  exchange?: JsonExchange;
  pair: string;
  lastPrice: number;
  priceTrigger: number;
  priceLimit: number;
  orderSize: number;
  period: number;
  volume: number;
  volumeExecuted: number;
  status: number;
  mode: string;
  quote: false;
  message: string;
  state: TaskState;
  rights: boolean;
  token: string;
  createdAt: string;
  updatedAt: string;
}
